module.exports = __webpack_public_path__ + "img/Frame kantoor.6a2db67a.jpg";